import fireworksComponent from "ags/components/fireworks-component";
import { SparkResult } from "ags/integration/model/results/spark-result";
import gameiomModel from "gameiom/model/gameiom-model";
import Components from "slotworks/components/components";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import gameState from "slotworks/model/game-state";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import Spin from "slotworks/state-machine/standard/states/spin";
import SparkBehaviour from "../behaviours/spark-behaviour";

interface SparkData {
    x: number;
    y: number;
    upgradeLevel?: number;
}

export default class AGSSpin extends Spin {

    protected behaviours = new Map<SymbolComponent, SparkBehaviour>();
    protected behavioursFinished: boolean;
    protected spinFinished: boolean;
    protected numberOfSparks = 0;
    protected willSkip: boolean;

    public onEnter() {
        super.onEnter();
        if (gameiomModel.disableSpinSkip) {
            SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);
        }
        this.willSkip = false;
        this.behavioursFinished = true;
        this.spinFinished = false;
        this.numberOfSparks = 0;
        this.attachWildBehaviours();
    }

    public onExit() {
        this.behaviours.forEach((behaviour, symbol) => {
            behaviour.destroy();
            symbol.removeBehaviour(behaviour);
        });

        this.behaviours.clear();

        super.onExit();
    }

    public complete(behavioursComplete?: boolean) {
        if (behavioursComplete) {
            this.behavioursFinished = true;
        } else {
            this.spinFinished = true;
        }

        if (this.spinFinished && this.behavioursFinished) {
            if (this.willSkip) {
                super.skip();
            } else {
                super.complete();
            }
        }
    }

    public skip() {
        this.willSkip = true;
        this.complete();
    }

    protected getWildBehaviourInstance(symbol: SymbolComponent, upgradeLevel: number) {
        return new SparkBehaviour(symbol, upgradeLevel, fireworksComponent);
    }

    protected attachWildBehaviours() {
        const wildSymbolPositions: SparkData[] = [];
        const sparkResults = gameState.getCurrentGame().getCurrentRecord().getResultsOfType(SparkResult);

        if (sparkResults.length) {
            for (const position of sparkResults[0].emitPositions) {
                wildSymbolPositions.push({ x: position.x, y: position.y });
            }

            if (sparkResults[0].upgrade) {
                wildSymbolPositions[Math.floor(Math.random() * wildSymbolPositions.length)].upgradeLevel = sparkResults[0].state;
            }
        }

        wildSymbolPositions.forEach((symbolPosition) => {
            const symbol = Components.matrix.getSymbol(symbolPosition.x, symbolPosition.y);
            const behaviour = this.getWildBehaviourInstance(symbol, symbolPosition.upgradeLevel);
            symbol.addBehaviour(behaviour);
            behaviour.animationComplete.addOnce(() => this.sparkComplete());

            this.behaviours.set(symbol, behaviour);
            this.behavioursFinished = false;
            this.numberOfSparks++;
        });
    }

    protected sparkComplete() {
        this.numberOfSparks--;

        if (this.numberOfSparks <= 0) {
            this.complete(true);
        }
    }
}
